var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.use,style:({ '--bg-color': _vm.bgc || _vm.color[0], '--lg-color': _vm.lgc || _vm.color[1] })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }